import PropTypes from 'prop-types';
import React from 'react';

import { Meta, Footer } from '$partials/global/index.js';
import { NavigationPageWrapper, NavigationButton } from '$partials/navigation/index.js';
import { GridWrapper } from '$partials/grid/layout/index.js';
import GridModuleDispatcher from '$partials/grid/dispatcher.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const HomePage = (props) => {
    const page = props.data.page;

    return (
        <>
            <Meta
                description={page.searchDescription || page.listingText}
                domain={props.domain}
                image={page.listingImage}
                page={page}
                title='Bureau for Visual Affairs' />

            <NavigationPageWrapper {...props.data?.navigation}>
                <main id='main-content'>
                    <div className='p-1'>

                        {/* Header */}
                        <header
                            className='py-20 sm:pb-40 sm:pt-34 md:pb-45 md:pt-30 lg:pt-40 lg:pb-80 layout-container flex flex-col gap-20 sm:gap-30 md:gap-40 lg:gap-50 bg-foreground rounded mb-1'
                            style={{ backgroundColor: page.headerColour }}>
                            <h1 className='type-style-hero px-layout-item'>
                                <span>Bureau for</span>
                                <br></br>
                                <span>Visual Affairs</span>
                            </h1>

                            {page?.headerCopy &&
                                <div
                                    className='type-style-2 px-layout-item max-w-[20em] sm:max-w-[40em] sm:columns-2 sm:gap-30 md:gap-40 lg:gap-50 rich-text mb-30 sm:mb-0'
                                    dangerouslySetInnerHTML={{ __html: page.headerCopy }} />
                            }

                            <NavigationButton />
                        </header>

                        {/* Outer grid */}
                        <GridWrapper>
                            {page?.grid?.map((item, idx) => {
                                if (!item) { return null; }

                                return (
                                    <GridModuleDispatcher
                                        {...item}
                                        key={idx} />
                                );
                            })}
                        </GridWrapper>

                        <Footer
                            mailchimpId={props?.data?.mailchimpId?.mailchimpId}
                            {...props?.data?.footer} />
                    </div>
                </main>
            </NavigationPageWrapper>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    data: PropTypes.shape({
        page: PropTypes.object,
        footer: PropTypes.object,
        navigation: PropTypes.object,
        mailchimpId: PropTypes.object,
    }),
    domain: PropTypes.string,
};

HomePage.propTypes = propTypes;

export default HomePage;
